import * as React from 'react';
import Stack from '@mui/material/Stack';

interface DemoContainerProps {
  components: string[];
  children: React.ReactNode;
}

/**
 * Local replacement for the removed `@mui/x-date-pickers/internals/demo`
 * DemoContainer (that internal, docs-only path no longer exists in MUI X v8+).
 * Reproduces the same layout it previously produced for this project's usage
 * (one or two DatePicker children): responsive row/column Stack with the
 * same spacing and min-width rules.
 */
export function DemoContainer({ children }: DemoContainerProps) {
  return (
    <Stack
      direction={{ xs: 'column', lg: 'row' }}
      spacing={{ xs: 3, lg: 2 }}
      sx={{
        overflow: 'auto',
        pt: 1,
        '& > .MuiTextField-root, & > .MuiPickersTextField-root': {
          minWidth: 200,
        },
      }}
    >
      {children}
    </Stack>
  );
}
